import { useState, useEffect } from 'react';

const ROW_HEIGHT = 44; // py-3 padding + content ≈ 44px per table row
const MOBILE_OVERHEAD = 300; // header(56) + nav+safe(69) + card chrome(52) + search(42) + table header(40) + pagination(25) + padding/margins(16)
const MIN_PAGE_SIZE = 8;
const DESKTOP_PAGE_SIZE = 15;

/**
 * Calculates how many table rows fit on screen based on viewport height.
 * On mobile (<1024px), dynamically computes page size from available space.
 * On desktop, returns the fixed default of 15.
 */
export function useDynamicPageSize(): number {
  const [pageSize, setPageSize] = useState(() => {
    if (typeof window === 'undefined') return DESKTOP_PAGE_SIZE;
    if (window.innerWidth < 1024) {
      const available = window.innerHeight - MOBILE_OVERHEAD;
      return Math.max(MIN_PAGE_SIZE, Math.floor(available / ROW_HEIGHT));
    }
    return DESKTOP_PAGE_SIZE;
  });

  useEffect(() => {
    const calculate = () => {
      const isMobile = window.innerWidth < 1024;
      if (!isMobile) {
        setPageSize(DESKTOP_PAGE_SIZE);
        return;
      }
      const available = window.innerHeight - MOBILE_OVERHEAD;
      setPageSize(Math.max(MIN_PAGE_SIZE, Math.floor(available / ROW_HEIGHT)));
    };

    window.addEventListener('resize', calculate);
    return () => window.removeEventListener('resize', calculate);
  }, []);

  return pageSize;
}
